"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.POTTY_TRAINING_OPTION = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var cloudfront_bundle_config_1 = require("../bundler-v2/data/cloudfront-bundle-config");
var bundle_input_1 = require("../bundler-v2/store/bundle-input");
var sizes_1 = require("../bundler-v2/utils/sizes");
var progress_bar_1 = __importDefault(require("../shared-components/progress-bar"));
var stepper_1 = __importDefault(require("../shared-components/stepper"));
var names_1 = __importDefault(require("./steps/names"));
var potty_training_1 = __importDefault(require("./steps/potty-training"));
var weight_and_pattern_genders_1 = __importDefault(require("./steps/weight-and-pattern-genders"));
/**
 * @todo what should happen if the customer provides both a title and a first name? Concatenating them looks kind of weird.
 */
/** @todo move to shared-components */
var Spinner = function (_a) {
    var className = _a.className, style = _a.style;
    return (react_1.default.createElement("svg", { className: className, style: __assign({ height: '1rem', width: '1rem' }, style), xmlns: 'http://www.w3.org/2000/svg', fill: 'none', viewBox: '0 0 24 24' },
        react_1.default.createElement("circle", { className: 'opacity-25', cx: '12', cy: '12', r: '10', stroke: 'currentColor', strokeWidth: '2' }),
        react_1.default.createElement("path", { className: 'opacity-75', fill: 'currentColor', d: 'M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z' })));
};
var uppercaseFirstLetterOfEachWord = function (str) {
    var words = str.split(' ');
    try {
        var uppercasedWords = words.map(function (word) { var _a; return (((_a = word[0]) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || '') + word.substring(1); });
        return uppercasedWords.join(' ').trim();
    }
    catch (error) {
        // if this fails due to weird input, we don't want to block the user from using the bundler
        return str;
    }
};
var NavBar = function (_a) {
    var nextButtonEnabled = _a.nextButtonEnabled, backButtonEnabled = _a.backButtonEnabled, nextButtonHidden = _a.nextButtonHidden, backButtonHidden = _a.backButtonHidden, refCallback = _a.refCallback, maxWidth = _a.maxWidth, goNext = _a.goNext, goBack = _a.goBack, beforeGoNext = _a.beforeGoNext, nextText = _a.nextText, backText = _a.backText, beforeGoBack = _a.beforeGoBack, nextLoading = _a.nextLoading;
    var handleNextClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var allowedToGoNext;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!nextButtonEnabled)
                        return [2 /*return*/];
                    if (!beforeGoNext) return [3 /*break*/, 2];
                    return [4 /*yield*/, beforeGoNext()];
                case 1:
                    allowedToGoNext = _a.sent();
                    if (allowedToGoNext)
                        goNext();
                    return [3 /*break*/, 3];
                case 2:
                    goNext();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleBackClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var allowedToGoBack;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!backButtonEnabled)
                        return [2 /*return*/];
                    if (!beforeGoBack) return [3 /*break*/, 2];
                    return [4 /*yield*/, beforeGoBack()];
                case 1:
                    allowedToGoBack = _a.sent();
                    if (allowedToGoBack)
                        goBack();
                    return [3 /*break*/, 3];
                case 2:
                    goBack();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    // We use an outer container which we bring out of flow by giving it position: fixed coupled with the inner visible bottom bar div to create
    // a bar that is fixed to the bottom. The inner bottom bar is given the same max width as the bundler.
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'z20 position-fixed bottom-0 width-100' },
            react_1.default.createElement("div", { ref: refCallback, className: 'bg-white width-100 padding-horizontal-6 width-100 h-16 flex-container align-justify align-middle border-very-light-pink', style: { maxWidth: maxWidth, boxShadow: '1px 0px 7px rgba(0,0,0,0.1)', borderTopWidth: 1, borderTopStyle: 'solid' } },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: (0, classnames_1.default)('padding-vertical-1 padding-horizontal-2 padding-vertical-2 flex-container align-center align-middle rounded-base text-base', backButtonHidden && 'hide', backButtonEnabled ? 'cursor-pointer' : 'cursor-default text-brownish-grey'), "aria-disabled": !backButtonEnabled, onClick: handleBackClick }, backText ? backText : 'Back')),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: (0, classnames_1.default)('padding-vertical-1 padding-horizontal-8 padding-vertical-2 flex-container align-center align-middle rounded-base bg-wisteria text-base text-white', nextButtonHidden && 'hide', nextButtonEnabled ? 'cursor-pointer' : 'cursor-default bg-very-light-pink'), "aria-disabled": !backButtonEnabled, onClick: handleNextClick },
                        nextLoading && (react_1.default.createElement(Spinner, { className: 'animate-spin margin-right-2 text-white', style: {
                                marginBottom: 3, // deal with the fact that the Oakes Grotesk font is not vertically centered
                            } })),
                        nextText ? nextText : 'Next'))))));
};
exports.POTTY_TRAINING_OPTION = {
    YES: 'yes',
    NOT_YET: 'not_yet',
    JUST_STARTING: 'just_starting',
};
var QuizDiaperBundle = function (_a) {
    var e_1, _b;
    var cmsSettings = _a.cmsSettings, onFinishQuiz = _a.onFinishQuiz;
    var _c = __read((0, react_1.useState)({}), 2), formData = _c[0], setFormData = _c[1];
    // Set up properties on bundleInputStore so that we can communicate with the bundler. We use zustand here mainly as a way to get typed persistence
    // between server-rendered pages. If we ever want to render the quiz on a different page than the bundler, this gives us a nice interface to store
    // data in localStorage or the URL and extract it once we've redirected to the bundler page.
    var useBundleInputStore = (0, bundle_input_1.getBundleInputStore)().useBundleInputStore;
    var changePresetSizes = useBundleInputStore(function (state) { return state.changePresetSizes; });
    var changePresetPreferredPatternGender = useBundleInputStore(function (state) { return state.changePresetPreferredPatternGender; });
    var changePresetDiaperSizeRationale = useBundleInputStore(function (state) { return state.changePresetDiaperSizeRationale; });
    var changePresetTrainingPantSizeRational = useBundleInputStore(function (state) { return state.changePresetTrainingPantSizeRational; });
    var changePresetPatternStepHeader = useBundleInputStore(function (state) { return state.changePresetPatternStepHeader; });
    var changePresetSizeStepHeader = useBundleInputStore(function (state) { return state.changePresetSizeStepHeader; });
    var resetBundleInputStore = useBundleInputStore(function (state) { return state.reset; });
    var submit = function (data) {
        var _a;
        // Clear any state from previous quiz use. Zustand will automatically hydrate, but we can clear what it hydrates by resetting the sate,
        // which will reset both the store's in-memory and persisted state.
        resetBundleInputStore();
        var selectedSizes = [];
        if (data.babyWeight) {
            var _b = (function () {
                switch (data.babyWeight) {
                    case '8_and_under_lbs':
                        if (data.pottyTraining === 'not_yet')
                            return { selectedDiaperSize: 'diaper_n', selectedTrainingSize: undefined };
                        else if (data.pottyTraining === 'just_starting')
                            return { selectedDiaperSize: 'diaper_n', selectedTrainingSize: undefined };
                        return { selectedDiaperSize: undefined, selectedTrainingSize: undefined };
                    case '8_10_lbs':
                        if (data.pottyTraining === 'not_yet')
                            return { selectedDiaperSize: 'diaper_1', selectedTrainingSize: undefined };
                        else if (data.pottyTraining === 'just_starting')
                            return { selectedDiaperSize: 'diaper_1', selectedTrainingSize: undefined };
                        return { selectedDiaperSize: undefined, selectedTrainingSize: undefined };
                    case '10_14_lbs':
                        if (data.pottyTraining === 'not_yet')
                            return { selectedDiaperSize: 'diaper_2', selectedTrainingSize: undefined };
                        else if (data.pottyTraining === 'just_starting')
                            return { selectedDiaperSize: 'diaper_2', selectedTrainingSize: undefined };
                        return { selectedDiaperSize: undefined, selectedTrainingSize: undefined };
                    case '14_18_lbs':
                        if (data.pottyTraining === 'not_yet')
                            return { selectedDiaperSize: 'diaper_3', selectedTrainingSize: undefined };
                        else if (data.pottyTraining === 'just_starting')
                            return { selectedDiaperSize: 'diaper_3', selectedTrainingSize: 'training_12_24' };
                        return { selectedDiaperSize: undefined, selectedTrainingSize: 'training_12_24' };
                    case '18_22_lbs':
                        if (data.pottyTraining === 'not_yet')
                            return { selectedDiaperSize: 'diaper_3', selectedTrainingSize: undefined };
                        else if (data.pottyTraining === 'just_starting')
                            return { selectedDiaperSize: 'diaper_3', selectedTrainingSize: 'training_2t_3t' };
                        return { selectedDiaperSize: undefined, selectedTrainingSize: 'training_2t_3t' };
                    case '22_27_lbs':
                        if (data.pottyTraining === 'not_yet')
                            return { selectedDiaperSize: 'diaper_4', selectedTrainingSize: undefined };
                        else if (data.pottyTraining === 'just_starting')
                            return { selectedDiaperSize: 'diaper_4', selectedTrainingSize: 'training_2t_3t' };
                        return { selectedDiaperSize: undefined, selectedTrainingSize: 'training_2t_3t' };
                    case '27_32_lbs':
                        if (data.pottyTraining === 'not_yet')
                            return { selectedDiaperSize: 'diaper_5', selectedTrainingSize: undefined };
                        else if (data.pottyTraining === 'just_starting')
                            return { selectedDiaperSize: 'diaper_5', selectedTrainingSize: 'training_2t_3t' };
                        return { selectedDiaperSize: undefined, selectedTrainingSize: 'training_2t_3t' };
                    case '32_35_lbs':
                        if (data.pottyTraining === 'not_yet')
                            return { selectedDiaperSize: 'diaper_5', selectedTrainingSize: undefined };
                        else if (data.pottyTraining === 'just_starting')
                            return { selectedDiaperSize: 'diaper_5', selectedTrainingSize: 'training_3t_4t' };
                        return { selectedDiaperSize: undefined, selectedTrainingSize: 'training_3t_4t' };
                    case '35_38_lbs':
                        if (data.pottyTraining === 'not_yet')
                            return { selectedDiaperSize: 'diaper_6', selectedTrainingSize: undefined };
                        else if (data.pottyTraining === 'just_starting')
                            return { selectedDiaperSize: 'diaper_6', selectedTrainingSize: 'training_3t_4t' };
                        return { selectedDiaperSize: undefined, selectedTrainingSize: 'training_3t_4t' };
                    case '38_plus_lbs':
                        if (data.pottyTraining === 'not_yet')
                            return { selectedDiaperSize: 'diaper_6', selectedTrainingSize: undefined };
                        else if (data.pottyTraining === 'just_starting')
                            return { selectedDiaperSize: 'diaper_6', selectedTrainingSize: 'training_4t_5t' };
                        return { selectedDiaperSize: undefined, selectedTrainingSize: 'training_4t_5t' };
                }
            })(), selectedDiaperSize = _b.selectedDiaperSize, selectedTrainingSize = _b.selectedTrainingSize;
            if (selectedDiaperSize)
                selectedSizes.push(selectedDiaperSize);
            if (selectedTrainingSize)
                selectedSizes.push(selectedTrainingSize);
            changePresetSizes(selectedSizes);
            if (selectedDiaperSize) {
                var friendlyName = sizes_1.diaperKeyToFriendlyName[selectedDiaperSize];
                changePresetDiaperSizeRationale("*Based on your baby's weight, we recommend a Size ".concat(friendlyName, "!"));
            }
            if (selectedTrainingSize) {
                var friendlyName = sizes_1.trainingKeyToFriendlyName[selectedTrainingSize];
                changePresetTrainingPantSizeRational("*Based on your baby's weight, we recommend a Size ".concat(friendlyName, "!"));
            }
        }
        var preferredPatternGender;
        if (data.preferredPatternGenders) {
            var numBoyPatternsSelected = data.preferredPatternGenders.reduce(function (total, gender) { return total + (gender === cloudfront_bundle_config_1.GENDER.BOY ? 1 : 0); }, 0);
            var numGirlPatternsSelected = data.preferredPatternGenders.reduce(function (total, gender) { return total + (gender === cloudfront_bundle_config_1.GENDER.GIRL ? 1 : 0); }, 0);
            var numNeutralPatternsSelected = data.preferredPatternGenders.reduce(function (total, gender) { return total + (gender === cloudfront_bundle_config_1.GENDER.NEUTRAL ? 1 : 0); }, 0);
            // If the user selects 2 patterns, with 1 gender and 1 neutral, set the gender as preferred.
            // If the user selects 2 patterns, with 1 boy and 1 girl, don't set a preferred gender.
            // Only if the user selects more gender neutral patterns than both boy and girl patterns do we set the preferred gender to neutral.
            if (numBoyPatternsSelected > numGirlPatternsSelected) {
                preferredPatternGender = 'boy';
                changePresetPreferredPatternGender('boy');
            }
            else if (numGirlPatternsSelected > numBoyPatternsSelected) {
                preferredPatternGender = 'girl';
                changePresetPreferredPatternGender('girl');
            }
            else if (numNeutralPatternsSelected > numBoyPatternsSelected && numNeutralPatternsSelected > numGirlPatternsSelected) {
                preferredPatternGender = 'neutral';
                changePresetPreferredPatternGender('neutral');
            }
        }
        if (data.babyTitle) {
            changePresetPatternStepHeader("Select Designs for ".concat(data.babyTitle));
        }
        if (data.babyFirstName) {
            changePresetSizeStepHeader("Select ".concat(uppercaseFirstLetterOfEachWord(data.babyFirstName), "'s Size(s)"));
        }
        var properties = {};
        var map = { boy: 'Boy', girl: 'Girl', neutral: 'Neutral' };
        var firstSize = selectedSizes[0]; // if we are choosing a mixed bundle for the customer we'll only send the diaper size to Klaviyo
        // Being very careful about what we send to Klaviyo to ensure we don't accidentally overwrite a property for a user in Klaviyo's database.
        if (firstSize)
            properties.quizRecommendedSize = firstSize;
        if (preferredPatternGender)
            properties.quizDesignStylePreference = map[preferredPatternGender];
        (_a = window._learnq) === null || _a === void 0 ? void 0 : _a.identify(properties);
    };
    var _d = __read((0, react_1.useState)(0), 2), activeStepIndex = _d[0], setActiveStepIndex = _d[1];
    // Step setters: merge step settings into existing formData and record responses to Klaviyo.
    var setNamesFormData = function (data) {
        var _a;
        // Identify the email for klaviyo and send an event. We have to request the track in a callback function
        // because the track event will fail to be recorded if the track code runs before the user is identified.
        // https://community.klaviyo.com/analytics-and-deliverability-72/send-track-and-identify-in-the-same-call-using-javascript-api-5512?postid=19888#post19888
        // Also, it's important that this email collection step comes first, because in subsequent steps, we can
        // call identify again and the properties will be added to the same customer identified here.
        var onIdentify = function () {
            var _a;
            (_a = window._learnq) === null || _a === void 0 ? void 0 : _a.track('Submitted email in diaper bundler quiz', {});
        };
        var properties = {};
        // Being very careful about what we send to Klaviyo to ensure we don't accidentally overwrite a property for a user in Klaviyo's database.
        if (data.email)
            properties.$email = data.email;
        if (data.parentFirstName)
            properties.$first_name = data.parentFirstName;
        if (data.babyFirstName)
            properties.quizBabyName = data.babyFirstName;
        if (data.babyTitle)
            properties.quizBabyTitle = data.babyTitle;
        (_a = window._learnq) === null || _a === void 0 ? void 0 : _a.identify(properties, undefined, undefined, onIdentify);
        setFormData(function (existingData) { return (__assign(__assign({}, existingData), { parentFirstName: data.parentFirstName, email: data.email, babyTitle: data.babyTitle, babyFirstName: data.babyFirstName })); });
    };
    var setPottyTrainingFormData = function (data) {
        var _a;
        var _b;
        var map = (_a = {},
            _a[exports.POTTY_TRAINING_OPTION.NOT_YET] = 'Diapers',
            _a[exports.POTTY_TRAINING_OPTION.JUST_STARTING] = 'Mixed',
            _a[exports.POTTY_TRAINING_OPTION.YES] = 'Training Pants',
            _a);
        var properties = {};
        // Being very careful about what we send to Klaviyo to ensure we don't accidentally overwrite a property for a user in Klaviyo's database.
        if (data.pottyTraining)
            properties.quizRecommendedBundle = map[data.pottyTraining];
        (_b = window._learnq) === null || _b === void 0 ? void 0 : _b.identify(properties);
        setFormData(function (existingData) { return (__assign(__assign({}, existingData), { pottyTraining: data.pottyTraining })); });
    };
    var setWeightAndPatternsFormDataAndSubmit = function (data) {
        // TODO: come up with a solution for this that allows us to use the function argument form of setFormData
        // like in the other functions above
        var updatedFormData = __assign(__assign({}, formData), { babyWeight: data.babyWeight, preferredPatternGenders: data.preferredPatternGenders });
        // We don't record any responses to Klaviyo here because the submit function does it instead. We do this to take advantage of the response
        // transformations that the submit function already does.
        setFormData(function () { return updatedFormData; });
        submit(updatedFormData);
    };
    var availablePatterns = [];
    try {
        for (var _e = __values(cmsSettings.patternConfigs.entries()), _f = _e.next(); !_f.done; _f = _e.next()) {
            var _g = __read(_f.value, 2), index = _g[0], config = _g[1];
            availablePatterns.push({ key: index, gender: config.gender, image: config.image });
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
        }
        finally { if (e_1) throw e_1.error; }
    }
    // unfortunately this state is not the only source of truth for selected patterns, but we do that so that we can keep consistent the "commit" step
    // where we edit form data on submit of each step, including the pattern selection step, while keeping track of the particular patterns that the
    // user selected
    var _h = __read((0, react_1.useState)(new Set()), 2), selectedPatternKeys = _h[0], setSelectedPatternKeys = _h[1];
    // deal with the complexities of having a fixed bottom nav
    var _j = __read((0, react_1.useState)(0), 2), navHeight = _j[0], setNavHeight = _j[1];
    var navCallback = (0, react_1.useCallback)(function (ref) {
        var height = (function () {
            if (ref === null)
                return 0;
            return ref.clientHeight;
        })();
        setNavHeight(height);
    }, []);
    var MAX_WIDTH = 640;
    // we have to give the content a bottom margin at least equal to the height of the bottom nav, but we choose to also add 20px for a nice look
    var marginBottom = navHeight + 20;
    // create shared props for the nav bar on each step
    var navBarProps = {
        refCallback: navCallback,
        maxWidth: MAX_WIDTH,
        goNext: function () { return setActiveStepIndex(function (prev) { return prev + 1; }); },
        goBack: function () { return setActiveStepIndex(function (prev) { return prev - 1; }); },
    };
    return (react_1.default.createElement("div", { className: 'margin-horizontal-auto bg-white height-100 width-100', style: { maxWidth: MAX_WIDTH, marginBottom: marginBottom } },
        react_1.default.createElement("div", { className: 'position-relative z2 height-100 bg-white' },
            react_1.default.createElement(stepper_1.default, { activeIndex: activeStepIndex, onStepClick: setActiveStepIndex },
                react_1.default.createElement(stepper_1.default.StepsDisplay, null, function (_a) {
                    var numSteps = _a.numSteps, activeIndex = _a.activeIndex;
                    var progressBarValues = [{ value: (activeIndex || 0) + 1, color: '#ffb3ab' }];
                    // avoid collapsing margins causing issues
                    var progressBarHeight = 12;
                    var distanceFromTop = 10;
                    return (react_1.default.createElement("div", { style: { flex: 1, height: progressBarHeight + distanceFromTop, paddingLeft: 10, paddingRight: 10, paddingTop: distanceFromTop } },
                        react_1.default.createElement(progress_bar_1.default, { values: progressBarValues, outOf: numSteps, outerStyle: { backgroundColor: 'rgba(255, 179, 171, 0.28)' }, innerClassName: 'rounded' })));
                }),
                react_1.default.createElement(stepper_1.default.Step, null,
                    react_1.default.createElement(names_1.default, { initialStepFormData: formData, setStepFormData: setNamesFormData, NavBar: function (navBarStepProps) { return react_1.default.createElement(NavBar, __assign({}, navBarStepProps, navBarProps)); } })),
                react_1.default.createElement(stepper_1.default.Step, null,
                    react_1.default.createElement(potty_training_1.default, { initialStepFormData: formData, setStepFormData: setPottyTrainingFormData, NavBar: function (navBarStepProps) { return react_1.default.createElement(NavBar, __assign({}, navBarStepProps, navBarProps)); } })),
                react_1.default.createElement(stepper_1.default.Step, null,
                    react_1.default.createElement(weight_and_pattern_genders_1.default, { initialStepFormData: formData, setStepFormDataAndSubmit: setWeightAndPatternsFormDataAndSubmit, selectedPatternKeys: selectedPatternKeys, setSelectedPatternKeys: setSelectedPatternKeys, availablePatterns: availablePatterns, babyFirstName: formData.babyFirstName, NavBar: function (navBarStepProps) { return react_1.default.createElement(NavBar, __assign({}, navBarStepProps, navBarProps, { goNext: function () { return onFinishQuiz === null || onFinishQuiz === void 0 ? void 0 : onFinishQuiz(); } })); } }))))));
};
exports.default = QuizDiaperBundle;
